exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".g-signin-button[data-v-4fdaf568]{display:inline-block;padding:4px 8px;border-radius:3px;background-color:#3c82f7;color:#fff;box-shadow:0 3px 0 #0f69ff;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4fdaf568","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Auth/signup.vue
// module id = 321
// module chunks = 0